<template>
  <v-btn
    color="error"
    text
    data-method="delete"
    dense
    @click="logout"
  >
    <v-icon> mdi-logout </v-icon>
    ログアウト
  </v-btn>
</template>

<script>
export default {
  methods: {
    logout () {
      this.$store.dispatch('UserAuthStore/logOut')
        .then((response) => {
          this.$router.push('/user_auths/sign_in')
        })
        .catch((e) => {
          const payload = {
            status: e.response.status,
            message: 'ログアウト出来ませんでした'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    }
  }
}
</script>
